import { CommonModule, } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { YztUploadComponent } from './yzt-upload.component';

import { NgZorroAntdModule } from 'ng-zorro-antd';
export class YztUploadModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        CommonModule,
        FormsModule,
        NgZorroAntdModule
    ],
    declarations: [
        YztUploadComponent
    ],
    exports: [YztUploadComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function YztUploadModule_tsickle_Closure_declarations() {
/** @type {?} */
YztUploadModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
YztUploadModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
